import apiClient from "../lib/apiClient";
import type { AddressDto, AddressResponse, PageResponse } from "./types";

export interface ArtistMiniInLieuResponse {
  id: string;
  name: string;
  description?: string;
  photoLink?: string;
}

export interface LieuDto {
  name: string;
  description?: string;
  addressName?: string;
  address?: AddressDto;
  artistIds?: string[];
}

export interface LieuResponse {
  id: string;
  name: string;
  description?: string;
  addressName?: string;
  address?: AddressResponse;
  artists?: ArtistMiniInLieuResponse[];
  createdAt: string;
  updatedAt: string;
}

export interface LieuSearchParams {
  search?: string;
  city?: string;
  page?: number;
  size?: number;
  sort?: string;
}

export async function listLieux(params: LieuSearchParams) {
  const { data } = await apiClient.get<PageResponse<LieuResponse>>("/parcours-lieu", { params });
  return data;
}

export async function getLieu(id: string) {
  const { data } = await apiClient.get<LieuResponse>(`/parcours-lieu/${id}`);
  return data;
}

export async function createLieu(dto: LieuDto) {
  const { data } = await apiClient.post<LieuResponse>("/parcours-lieu", dto);
  return data;
}

export async function updateLieu(id: string, dto: LieuDto) {
  const { data } = await apiClient.put<LieuResponse>(`/parcours-lieu/${id}`, dto);
  return data;
}

export async function deleteLieu(id: string) {
  await apiClient.delete(`/parcours-lieu/${id}`);
}
